import React, { Component } from 'react'
import Logo from '../Logo'
import { NavLink } from 'react-router-dom'

export class SideBar extends Component {
  render() {
    return (
      <div className='min-w-[260px] w-[260px] h-screen bg-white'>
        <div className='w-[260px] h-screen bg-white overflow-auto fixed shadow'>
           <div className='mt-[20px]'>
                <Logo />
           </div>
           <nav>
            <ul className='pl-[20px] pr-[20px] mt-[40px] flex flex-col gap-[4px]'>
                <li >
                    <NavLink to={'/'} className='bg-gray-100 rounded-[10px] p-[10px_12px] inline-block w-full text-[14px] font-semibold text-gray-600' href='#'>Əsas Slider</NavLink>
                </li>
                <li>
                    <NavLink to={'/company-about'} className='bg-gray-100 rounded-[10px] p-[10px_12px] inline-block w-full text-[14px] font-semibold text-gray-600' href='#'>Şirkət haqqında</NavLink>
                </li>
                <li>
                    <NavLink to={'/categores'} className='bg-gray-100 rounded-[10px] p-[10px_12px] inline-block w-full text-[14px] font-semibold text-gray-600' href='#'>Kateqoriyalar</NavLink>
                </li>
                <li>
                    <NavLink to={'/sub-categores'} className='bg-gray-100 rounded-[10px] p-[10px_12px] inline-block w-full text-[14px] font-semibold text-gray-600' href='#'>Alt Kateqoriyalar</NavLink>
                </li>
                <li>
                    <NavLink to={'/products'} className='bg-gray-100 rounded-[10px] p-[10px_12px] inline-block w-full text-[14px] font-semibold text-gray-600' href='#'>Məhsullar</NavLink>
                </li>
                <li>
                    <NavLink to={'/services'} className='bg-gray-100 rounded-[10px] p-[10px_12px] inline-block w-full text-[14px] font-semibold text-gray-600' href='#'>Xidmətlər</NavLink>
                </li>
                {/* <li>
                    <NavLink to={'/certificate'} className='bg-gray-100 rounded-[10px] p-[10px_12px] inline-block w-full text-[14px] font-semibold text-gray-600' href='#'>Sertifikatlar</NavLink>
                </li> */}
                {/* <li>
                    <NavLink to={'/thankyouletter'} className='bg-gray-100 rounded-[10px] p-[10px_12px] inline-block w-full text-[14px] font-semibold text-gray-600' href='#'>Təşəkkürnamələr</NavLink>
                </li> */}
                {/* <li>
                    <NavLink to={'/lisences'} className='bg-gray-100 rounded-[10px] p-[10px_12px] inline-block w-full text-[14px] font-semibold text-gray-600' href='#'>Lisenziyalar</NavLink>
                </li>
                <li>
                    <NavLink to={'/partners'} className='bg-gray-100 rounded-[10px] p-[10px_12px] inline-block w-full text-[14px] font-semibold text-gray-600' href='#'>Tərəfdaşlar</NavLink>
                </li>
               
                <li>
                    <NavLink to={'/mission'} className='bg-gray-100 rounded-[10px] p-[10px_12px] inline-block w-full text-[14px] font-semibold text-gray-600' href='#'>Şirkət Missiyamız</NavLink>
                </li> */}
                <li>
                    <NavLink to={'/contact'} className='bg-gray-100 rounded-[10px] p-[10px_12px] inline-block w-full text-[14px] font-semibold text-gray-600' href='#'>Əlaqə Vasitələri</NavLink>
                </li>
                <li>
                    <NavLink to={'/content'} className='bg-gray-100 rounded-[10px] p-[10px_12px] inline-block w-full text-[14px] font-semibold text-gray-600' href='#'>Content</NavLink>
                </li>
                {/* <li>
                    <NavLink to={'/acreditation'} className='bg-gray-100 rounded-[10px] p-[10px_12px] inline-block w-full text-[14px] font-semibold text-gray-600' href='#'>Akkreditasiya</NavLink>
                </li>
                <li>
                    <NavLink to={'/v-services'} className='bg-gray-100 rounded-[10px] p-[10px_12px] inline-block w-full text-[14px] font-semibold text-gray-600' href='#'>Voltmills Xidmətlər</NavLink>
                </li>
          
                <li>
                    <NavLink to={'/v-measure'} className='bg-gray-100 rounded-[10px] p-[10px_12px] inline-block w-full text-[14px] font-semibold text-gray-600' href='#'>Ölçmə avadanlığı</NavLink>
                </li>
                <li>
                    <NavLink to={'/v-about'} className='bg-gray-100 rounded-[10px] p-[10px_12px] inline-block w-full text-[14px] font-semibold text-gray-600' href='#'>Voltmills Haqqimizda</NavLink>
                </li> */}
          
                <li>
                    <NavLink to={'/language'} className='bg-gray-100 rounded-[10px] p-[10px_12px] inline-block w-full text-[14px] font-semibold text-gray-600' href='#'>Dil</NavLink>
                </li>
                <li>
                    <NavLink to={'/profile'} className='bg-gray-100 rounded-[10px] p-[10px_12px] inline-block w-full text-[14px] font-semibold text-gray-600' href='#'>Profile</NavLink>
                </li>
            </ul>
           </nav>
        </div>
      </div>
    )
  }
}

export default SideBar